import React, { useEffect, useState } from 'react'
import Button from '../../component/Button'
import classes from "./style.module.scss";
import { useLocation, useNavigate } from 'react-router-dom';
import SearchBox from '../../component/SearchBox';
import NormalSelect from '../../component/NormalSelect';
import IconComponent from '../../component/IconComponent';
import { Icons } from '../../assets';
import ResourcesTableList from './components/ResourcesTableList';
import ViewResources from './components/ViewResources';
import UploadResources from '../../modalComponents/UploadResources';
import SuccessModal from '../../modalComponents/SuccessModal';
import ConfirmationModal from '../../modalComponents/ConfirmationModal';
import { useDispatch } from 'react-redux';
import Exported from '../../service/endpoints';
import request from '../../service';
import { Toast } from '../../service/toast';
import { saveLoadingState } from '../../redux/reducers/loadingSlice';
import GetUserPermission from '../../component/GetUserPermission';


const ResourcesComponent = () => {
    const TECHNICAL_INSIGHTS = 'Technical Insights'
    const PRODUCT_INSIGHTS = 'Product Insights'
    const MARKETING_COLLATERAL = 'Marketing collateral'

    const RESOURCE_LIST = [
        { label: TECHNICAL_INSIGHTS, value: '1' },
        { label: PRODUCT_INSIGHTS, value: '2' },
        { label: MARKETING_COLLATERAL, value: '3' },
    ]

    const [activeTab, setActiveTab] = useState('1')
    const [uploadResource, setUploadResource] = useState(false)
    const [viewResources, setViewResources] = useState(false)
    const [showSuccessModal, setShowSuccessModal] = useState(false)
    const [searchInput, setSearchInput] = useState('')
    const [selectedId, setSelectedId] = useState(null)
    const [page, setPage] = useState(1);
    const [productList, setProductList] = useState({});
    const [isLoading, setisLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState(null);
    const [showDeletePopUp, setShowDeletePopUp] = useState(false)
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const addPermission = GetUserPermission({ key: 'add' });

    useEffect(() => {
        setSearchInput('')
        setSortConfig(null)
        setPage(1)
    }, [activeTab])

    useEffect(() => {
        getProductList()
    }, [page, sortConfig, searchInput, activeTab])

    useEffect(() => {
        if (location?.pathname) {
            const pathName = location?.search?.split('?type=')
            const pathById = location?.search?.split('?id=')
            const params = pathName[pathName?.length - 1]
            const paramsID = pathById[pathById?.length - 1]
            if (paramsID && pathById?.length > 1) {
                setViewResources(true)
            } else {
                setViewResources(false)
            }
            if (params && pathName?.length > 1) {
                setUploadResource(true)
            } else {
                setUploadResource(false)
            }
        }
    }, [location])

    const getResouceId = () => {
        const pathName = location?.search?.split('?id=')
        if (pathName?.length > 1) {
            const params = pathName[pathName?.length - 1]
            return params
        }
        return;
    }
    const getTabName = () => {
        return RESOURCE_LIST?.filter((x) => x?.value === activeTab)?.at(0)?.label
    }

    const handleChange = (value) => {
        setSearchInput(value)
    }

    const handleResourceClose = () => {
        setUploadResource(false)
        redirectBack()
        setSearchInput('')
    }

    const handleResourceSuccess = () => {
        setUploadResource(false)
        setShowSuccessModal(true)
        getProductList()
    }

    const redirectBack = () => {
        navigate(`/admin/resources`)
    }
    const redirectTo = () => {
        navigate(`?type=upload`)
    }

    const handleSuccessClose = () => {
        setShowSuccessModal(false)
        redirectBack()
    }

    const handleClose = () => {
        setShowDeletePopUp(false)
    }

    const handleDelete = (id) => {
        setShowDeletePopUp(true)
        setSelectedId(id)
    }

    const getProductList = async () => {
        setisLoading(true)
        let url = `${Exported.Endpoints.getResources}`
        let paramsObj = {
            page: page,
            limit: 10,
        }
        if (activeTab) {
            paramsObj['resourceType'] = activeTab
        }
        if (searchInput && searchInput !== '') {
            paramsObj['search'] = searchInput
        }
        if (sortConfig) {
            paramsObj['sort'] = sortConfig?.key
            paramsObj['sortOrder'] = sortConfig?.direction
        }

        await request({
            url: url,
            params: { ...paramsObj }
        }).then((res) => {
            if (res?.data?.status) {
                const obj = {
                    result: res?.data?.data?.list,
                    pageMeta: res?.data?.data?.pageMeta
                }
                setProductList(obj)
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        setisLoading(false)
    }


    const deleteProduct = async () => {
        dispatch(saveLoadingState(true))
        let url = `${Exported.Endpoints.getResourcesByID}/${selectedId}`

        const requestData = {
            id: selectedId,
        }
        await request({
            url: url,
            method: Exported.APIMethods.DELETE,
            data: requestData
        }).then(async (res) => {
            if (res?.data?.status) {
                getProductList()
                dispatch(saveLoadingState(false))
                setShowDeletePopUp(false)
                redirectBack()
                Toast({
                    type: 'success',
                    message: 'Deleted Successfully'
                })
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        dispatch(saveLoadingState(false))
        setShowDeletePopUp(false)
        redirectBack()
    }

    return (
        <>
            {viewResources ?
                <ViewResources title={getTabName()} handleDelete={handleDelete} resourceId={getResouceId()} /> :
                <div className={`${classes.manageUserWrapper}`}>
                    <div className={`w-[100%] flex items-center justify-between`}>
                        <div className={`layout-title`}>Resources</div>
                        <div className='flex items-center'>
                            <SearchBox value={searchInput} onChange={handleChange} placeholder={'Find by title, product name, product category...'} />
                            {addPermission &&
                                <Button text={"Upload"} className={'ml-5 !px-5'} StartIcon={Icons.uploadIcon} smallBtn onClick={() => redirectTo()} />
                            }
                        </div>
                    </div>
                    <div className={`${classes.headerList} w-[100%] flex items-center`}>
                        {RESOURCE_LIST?.map(({ label, value }) => <div className={`${classes.headerTab} ${activeTab === value ? classes.activeTab : ''}`} onClick={() => setActiveTab(value)}>{label}</div>)}
                    </div>
                    <div>
                        <ResourcesTableList activeTab={activeTab} searchInput={searchInput} handleDelete={handleDelete}
                            page={page}
                            setPage={setPage}
                            productList={productList}
                            isLoading={isLoading}
                            sortConfig={sortConfig}
                            getProductList={getProductList}
                        />
                    </div>
                </div>
            }

            {uploadResource ?
                <UploadResources isOpen={uploadResource} closePopUp={handleResourceClose} activeTab={activeTab} resourceId={getResouceId()} handleSuccessModal={handleResourceSuccess} />
                : null}
            {showSuccessModal ?
                <SuccessModal
                    isOpen={showSuccessModal}
                    closePopUp={handleSuccessClose}
                    successText={'Success!'}
                    boxAlign='center'
                    modalText={'New resources added successfully.'}
                />
                : null
            }
            {showDeletePopUp ?
                <ConfirmationModal
                    isOpen={showDeletePopUp}
                    handleSuccess={deleteProduct}
                    closePopUp={handleClose}
                    warningText={'Confirmation'}
                    modalText={'Are you sure to delete this resource?'}
                    confirmText={'Yes'}
                    cancelText={'No'}
                    primaryBtnConfirm={false}
                />
                : null
            }
        </>
    )
}

export default ResourcesComponent